import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AdminPrayerPage from "../pages/admin/prayer/page";
import AdminFieldNewsPage from "../pages/admin/field-news/page";
import AdminKBMInsightsPage from "../pages/admin/kbm-insights/page";
import AdminKBMNewsPage from "../pages/admin/kbm-news/page";
import AdminMissionFieldsPage from "../pages/admin/mission-fields/page";
import AdminPartnerChurches from "../pages/admin/partner-churches/page";
import AdminInquiriesPage from "../pages/admin/inquiries/page";
import AdminLoginPage from "../pages/admin/login/page";
import AdminRegisterPage from "../pages/admin/register/page";
import ProtectedRoute from "../components/feature/ProtectedRoute";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/admin/login",
    element: <AdminLoginPage />,
  },
  {
    path: "/admin/register",
    element: <AdminRegisterPage />,
  },
  {
    path: "/admin/prayer",
    element: (
      <ProtectedRoute>
        <AdminPrayerPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/field-news",
    element: (
      <ProtectedRoute>
        <AdminFieldNewsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/kbm-insights",
    element: (
      <ProtectedRoute>
        <AdminKBMInsightsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/kbm-news",
    element: (
      <ProtectedRoute>
        <AdminKBMNewsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/mission-fields",
    element: (
      <ProtectedRoute>
        <AdminMissionFieldsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/partner-churches",
    element: (
      <ProtectedRoute>
        <AdminPartnerChurches />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/inquiries",
    element: (
      <ProtectedRoute>
        <AdminInquiriesPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
